module.exports = __webpack_public_path__ + "static/media/Can Aydin.5158aa75.JPG";